module.exports = __webpack_public_path__ + "static/media/never-eve.919bea2f.svg";